import { Flex, Menu, MenuButton, MenuItem, MenuList, FlexProps } from '@chakra-ui/react';
import { useState } from 'react';
import { Icon } from '~/ui-components';
import { faAdd, faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { useLocalization } from '~/framework';
import { useStageEditor } from '../StageEditor';
import { AddOption } from '../StageEditorInterface';

type StageMenuProps = FlexProps & {
   index: number;
};

export function StageMenu({ index, ...props }: StageMenuProps) {
   const { _js } = useLocalization();

   const [isOpen, setIsOpen] = useState(false);

   const stageEditor = useStageEditor();

   const options = stageEditor.getAddMenuOptions(index);

   const optionLabels: Record<AddOption['name'], string> = {
      guide: _js('Guide'),
      wiki: _js('Wiki'),
      'external-training-module': _js('External Content'),
      'trainer-sign-off': _js('Stage Sign-Off'),
   };

   function handleClick(e: React.MouseEvent, index: number, optionName: AddOption['name']) {
      e.stopPropagation();
      setIsOpen(false);
      stageEditor.handleAddMenuSelection(index, optionName);
   }

   return (
      <Flex
         cursor="pointer"
         justifyContent="center"
         color="blueGray.600"
         padding={2}
         onClick={() => setIsOpen(true)}
         {...props}
      >
         <Menu isOpen={isOpen} onClose={() => setIsOpen(false)}>
            <MenuButton
               width="100px"
               type="button"
               role="button"
               aria-label={_js('Add Stage or Assessment (position %1)', `${index + 1}`)}
            >
               <Icon type={faAdd} />
               <Icon type={faCaretDown} />
            </MenuButton>
            <MenuList
               role="menu"
               aria-label={_js('Add Stage or Assessment Menu (position %1)', `${index + 1}`)}
            >
               {options.map(option => (
                  <MenuItem
                     key={option.name}
                     onClick={e => handleClick(e, index, option.name)}
                     isDisabled={option.isDisabled}
                  >
                     {optionLabels[option.name]}
                  </MenuItem>
               ))}
            </MenuList>
         </Menu>
      </Flex>
   );
}
